import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            formsReceived: 'forms/Forms',
            formReceived: 'forms/Form',
            formPagesReceived: 'forms/FormPages',
            formPageReceived: 'forms/FormPage',
            formPageSectionsReceived: 'forms/FormPageSections',
            formQuestionsReceived: 'forms/FormQuestions',
            formQuestionDocumentsReceived: 'forms/FormQuestionDocuments',
            formQuestionHelpReceived: 'forms/FormQuestionHelp',
            formQuestionSubHelpReceived: 'forms/FormQuestionSubHelp',
        }),
    },
    methods: {
        ...mapActions({
            FetchForms: 'forms/FetchForms',
            FetchFormsByAcademicSession: 'forms/FetchFormsByAcademicSession',
            FetchFormByTypeAcademicSession: 'forms/FetchFormByTypeAcademicSession',
            FetchFormPagesByFormID: 'forms/FetchFormPagesByFormID',
            FetchFormPageByFormSlugPageSlug: 'forms/FetchFormPageByFormSlugPageSlug',
            FetchFormPageSectionsByFormID: 'forms/FetchFormPageSectionsByFormID',
            FetchFormPageSectionsByFormPageID: 'forms/FetchFormPageSectionsByFormPageID',
            FetchFormQuestionsByFormID: 'forms/FetchFormQuestionsByFormID',
            FetchFormQuestionsByFormPageID: 'forms/FetchFormQuestionsByFormPageID',
            FetchFormQuestionDocumentsByFormPageID: 'forms/FetchFormQuestionDocumentsByFormPageID',
            FetchFormQuestionHelpByFormPageID: 'forms/FetchFormQuestionHelpByFormPageID',
            FetchFormQuestionSubHelpByFormPageID: 'forms/FetchFormQuestionSubHelpByFormPageID',
        }),
        LoadForms() {
            eventBus.$emit('forms-fetch:started');
            this.FetchForms()
                .then(() => {
                    this.forms = [...this.formsReceived];
                    eventBus.$emit('forms-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('forms-fetch:finished'));
        },
        LoadFormsByAcademicSession(academicSession) {
            eventBus.$emit('forms-fetch:started');
            this.FetchFormsByAcademicSession({ academicSession: academicSession })
                .then(() => {
                    this.forms = [...this.formsReceived];
                    eventBus.$emit('forms-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('forms-fetch:finished'));
        },
        LoadFormByTypeAcademicSession(type, academicSession) {
            eventBus.$emit('form-fetch:started');
            this.FetchFormByTypeAcademicSession({ type: type, academicSession: academicSession })
                .then(() => {
                    this.form = Object.assign({}, this.formReceived);
                    eventBus.$emit('form-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-fetch:finished'));
        },
        LoadFormPagesByFormID(formID) {
            eventBus.$emit('form-pages-fetch:started');
            this.FetchFormPagesByFormID({ formID: formID })
                .then(() => {
                    this.formPages = [...this.formPagesReceived];
                    eventBus.$emit('form-pages-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-pages-fetch:finished'));
        },
        LoadFormPageByFormSlugPageSlug(formSlug, pageSlug) {
            eventBus.$emit('form-page-fetch:started');
            this.FetchFormPageByFormSlugPageSlug({ formSlug: formSlug, pageSlug: pageSlug })
                .then(() => {
                    this.formPage = Object.assign({}, this.formPageReceived);
                    eventBus.$emit('form-page-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-page-fetch:finished'));
        },
        LoadFormPageSectionsByFormID(formID) {
            eventBus.$emit('form-page-sections-fetch:started');
            this.FetchFormPageSectionsByFormID({ formID: formID })
                .then(() => {
                    this.formPageSections = [...this.formPageSectionsReceived];
                    eventBus.$emit('form-page-sections-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-page-sections-fetch:finished'));
        },
        LoadFormPageSectionsByFormPageID(formPageID) {
            eventBus.$emit('form-page-sections-fetch:started');
            this.FetchFormPageSectionsByFormPageID({ formPageID: formPageID })
                .then(() => {
                    this.formPageSections = [...this.formPageSectionsReceived];
                    eventBus.$emit('form-page-sections-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-page-sections-fetch:finished'));
        },
        LoadFormQuestionsByFormID(formID) {
            eventBus.$emit('form-questions-fetch:started');
            this.FetchFormQuestionsByFormID({ formID: formID })
                .then(() => {
                    this.formQuestions = [...this.formQuestionsReceived];
                    eventBus.$emit('form-questions-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-questions-fetch:finished'));
        },
        LoadFormQuestionsByFormPageID(formPageID) {
            eventBus.$emit('form-questions-fetch:started');
            this.FetchFormQuestionsByFormPageID({ formPageID: formPageID })
                .then(() => {
                    this.formQuestions = [...this.formQuestionsReceived];
                    eventBus.$emit('form-questions-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-questions-fetch:finished'));
        },
        LoadFormQuestionDocumentsByFormPageID(formPageID) {
            eventBus.$emit('form-question-documents-fetch:started');
            this.FetchFormQuestionDocumentsByFormPageID({ formPageID: formPageID })
                .then(() => {
                    this.formQuestionDocuments = [...this.formQuestionDocumentsReceived];
                    eventBus.$emit('form-question-documents-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-question-documents-fetch:finished'));
        },
        LoadFormQuestionHelpByFormPageID(formPageID) {
            eventBus.$emit('form-question-help-fetch:started');
            this.FetchFormQuestionHelpByFormPageID({ formPageID: formPageID })
                .then(() => {
                    this.formQuestionHelp = [...this.formQuestionHelpReceived];
                    eventBus.$emit('form-question-help-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-question-help-fetch:finished'));
        },
        LoadFormQuestionSubHelpByFormPageID(formPageID) {
            eventBus.$emit('form-question-sub-help-fetch:started');
            this.FetchFormQuestionSubHelpByFormPageID({ formPageID: formPageID })
                .then(() => {
                    this.formQuestionSubHelp = [...this.formQuestionSubHelpReceived];
                    eventBus.$emit('form-question-sub-help-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('form-question-sub-help-fetch:finished'));
        },
        GetFormPageSections(formPageID) {
            return this.formPageSections?.filter(s => s.fkFormPageID == formPageID) || [];
        },
        GetFormPageSectionQuestions(sectionID) {
            return this.formQuestions?.filter(q => q.fkFormPageSectionID == sectionID) || [];
        },
        GetFormQuestionHelp(questionID) {
            return this.formQuestionHelp?.filter(h => h.fkFormQuestionID == questionID) || [];
        },
        GetFormQuestionDocuments(questionID) {
            return this.formQuestionDocuments?.filter(h => h.fkFormQuestionID == questionID) || [];
        },
        GetFormQuestionSubHelpByFormQuestionID(questionID) {
            return this.formQuestionSubHelp?.filter(h => h.fkFormQuestionID == questionID) || [];
        },
        GetFormQuestionSubHelpByFormQuestionHelpID(helpID) {
            return this.formQuestionSubHelp?.filter(sh => sh.fkFormQuestionHelpID == helpID) || [];
        },
        IsFormPageVisible(formPage) { return eval(formPage?.pageVisibilityRules) === true; },
        IsFormPageSectionVisible(formPageSection) { return eval(formPageSection?.sectionVisibilityRules) === true; },
        IsFormQuestionVisible(formQuestion) {
            return eval(formQuestion?.visibilityRules) === true || this.OverrideEvidenceFields.includes(formQuestion.id);
        },
        IsFormQuestionValid(formQuestion) {
            var applicationChecklistStatus = this.applicationChecklistStatuses?.find(s => s.fkFormQuestionID == formQuestion.id);

            if (applicationChecklistStatus?.status == 'Completed') return true;
            else if (formQuestion?.fieldValidationRules === null) return true;
            else if (this.BypassEvidenceFields?.some(f => f.formQuestionID == formQuestion.id)) {
                if (this.IsApplicationSubmitted) return eval(formQuestion?.fieldValidationRules) === true;
                else return true;
            }
            else return eval(formQuestion?.fieldValidationRules) === true;
        },
        IsFormPageValid(formPage) {
            let isPageValid = true;
            let formPageSections = this.formPageSections.filter(fq => fq.fkFormPageID == formPage.id);

            for (let j = 0; j < formPageSections?.length || 0; j++) {
                let formPageSection = formPageSections[j];

                if (!this.IsFormPageSectionVisible(formPageSection)) continue;

                let isFormPageSectionValid = this.IsFormPageSectionValid(formPageSection);

                if (isFormPageSectionValid === false) {
                    isPageValid = false;
                    break;
                }
            }

            return isPageValid;
        },
        IsFormPageSectionValid(formPageSection) {
            let isSectionValid = true;

            let formPageSectionQuestions = this.formQuestions.filter(fq => fq.fkFormPageSectionID == formPageSection.id);

            for (let j = 0; j < formPageSectionQuestions?.length || 0; j++) {
                let formQuestion = formPageSectionQuestions[j];

                if (!this.IsFormQuestionVisible(formQuestion)) continue;

                let isFormQuestionValid = this.IsFormQuestionValid(formQuestion);

                if (isFormQuestionValid === false) {
                    isSectionValid = false;
                    break;
                }
            }

            return isSectionValid;
        },
    },
};